import React from "react";
import useNotebookStore from "../../store/useNotebookStore";

const NotebookItem = ({
  notebook,
  index,
  handleNotebookView,
  handleNotebookEdit,
  handleDeleteNotebook,
  handleMoveToCardList,
  children,
}) => {
  const {
    viewingNotebook,
    editingNotebook,
    cardTitle,
    setCardTitle,
    setHasUnsavedChanges,
    isEditing,
  } = useNotebookStore();

  return (
    <div
      className={`notebook-list ${
        viewingNotebook === index || editingNotebook === index ? "active" : ""
      }`}
    >
      <div className="inner" onClick={(e) => handleNotebookView(index, e)}>
        <div className="notebook-info">
          <div>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                style={{
                  transform:
                    viewingNotebook === index || editingNotebook === index
                      ? "rotate(90deg)"
                      : "none",
                }}
              >
                <path
                  d="M9 5L16 12L9 19"
                  stroke="#3D90EF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {editingNotebook === index ? (
              <input
                value={cardTitle}
                placeholder="제목을 입력해주세요."
                onChange={(e) => {
                  setCardTitle(e.target.value);
                  setHasUnsavedChanges(true);
                }}
                maxLength={14}
                className="title-input w-[150px] lg:w-[180px] bg-transparent outline-none border-b border-b-[#3d90ef]"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <p className="w-[150px] lg:w-[180px]">{notebook.title}</p>
            )}

            <svg
              className="hide-mobile"
              xmlns="http://www.w3.org/2000/svg"
              width="2"
              height="24"
              viewBox="0 0 2 24"
              fill="none"
            >
              <path
                d="M1 1L1 23"
                stroke="black"
                strokeOpacity="0.4"
                strokeLinecap="round"
              />
            </svg>

            {editingNotebook !== index && <p className="hide-mobile">총 단어카드 {notebook.cards.length}개</p>}
          </div>
          <div>
            <p className="hide-mobile">{notebook.date.split(" ")[0]}</p>
            <svg
              className="hide-mobile"
              xmlns="http://www.w3.org/2000/svg"
              width="2"
              height="24"
              viewBox="0 0 2 24"
              fill="none"
            >
              <path
                d="M1 1L1 23"
                stroke="black"
                strokeOpacity="0.4"
                strokeLinecap="round"
              />
            </svg>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleNotebookEdit(index);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21 9.25V9.2C21 8.0799 21 7.51984 20.782 7.09202C20.5903 6.7157 20.2843 6.40974 19.908 6.21799C19.4802 6 18.9201 6 17.8 6L3 6M3 6L3 16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.7157 19.5903 4.09202 19.782C4.51984 20 5.0799 20 6.2 20H7M3 6L3 5.6C3 5.03995 3 4.75992 3.109 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H9.33726C9.58185 4 9.70415 4 9.81923 4.02763C9.92127 4.05213 10.0188 4.09253 10.1083 4.14736C10.2092 4.2092 10.2957 4.29568 10.4686 4.46863L12 6M16 14L18 16M11 21V18.5L18.5 11L21 13.5L13.5 21H11Z"
                  stroke={editingNotebook === index ? "#3D90EF" : "black"}
                  strokeOpacity={editingNotebook === index ? "1" : "0.4"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNotebook(notebook.id);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="24"
                viewBox="0 0 27 24"
                fill="none"
              >
                <path
                  d="M6.706 6V17.8C6.706 18.9201 6.706 19.4798 6.94963 19.9076C7.16393 20.2839 7.50564 20.5905 7.92624 20.7822C8.40393 21 9.02958 21 10.279 21H16.5447C17.7942 21 18.4189 21 18.8966 20.7822C19.3172 20.5905 19.6601 20.2839 19.8744 19.9076C20.1178 19.4802 20.1178 18.921 20.1178 17.8031V6M6.706 6H8.94129M6.706 6H4.4707M8.94129 6H17.8825M8.94129 6C8.94129 5.06812 8.94129 4.60241 9.11144 4.23486C9.33831 3.74481 9.77318 3.35523 10.3209 3.15224C10.7317 3 11.2527 3 12.2942 3H14.5295C15.571 3 16.0918 3 16.5026 3.15224C17.0503 3.35523 17.4853 3.74481 17.7122 4.23486C17.8824 4.6024 17.8825 5.06812 17.8825 6M17.8825 6H20.1178M20.1178 6H22.3531"
                  stroke="black"
                  strokeOpacity="0.4"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <button
          className={`border ${
            isEditing ? "border-[#ccc] text-[#ccc]" : "bg-[#3D90EF]"
          } px-4 py-[2px] rounded-[100px] notebook-btn`}
          onClick={() => handleMoveToCardList(notebook)}
          disabled={isEditing}
        >
          <span className={isEditing ? "text-[#ccc]" : "text-[#fff]"}>
            단어장 실행
          </span>
        </button>
      </div>
      {children}
    </div>
  );
};

export default NotebookItem;
